import { render, staticRenderFns } from "./generateInvoice.vue?vue&type=template&id=60558de9&"
import script from "./generateInvoice.vue?vue&type=script&lang=js&"
export * from "./generateInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports